import { useEffect, useState } from 'react';

/** Fetch next bookable start (epoch ms) per listing id from /api/listing-next-slots. */
const useNextSlots = (ids = []) => {
  const key = (ids || []).filter(Boolean).join(',');
  const [slots, setSlots] = useState({});
  useEffect(() => {
    if (!key || typeof window === 'undefined' || !window.fetch) return undefined;
    let cancelled = false;
    window
      .fetch(`/api/listing-next-slots?ids=${encodeURIComponent(key)}`, { credentials: 'same-origin' })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (!cancelled && data?.nextSlots) setSlots(data.nextSlots);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [key]);
  return slots;
};

export default useNextSlots;
